import { I18nPluralPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Table } from '../constants/table.constants';

@Pipe({
    name: 'daysPassed'
})
export class DaysPassedPipe implements PipeTransform {
    private _singleDay = this._i18n({
        value: '# day ago',
        meaning: 'Template for {1 Day} pluralization'
    });

    private _multipleDays = this._i18n({
        value: '# days ago',
        meaning: 'Template for {X Days} pluralization'
    });

    private _today = this._i18n({
        value: 'today'
    });

    constructor(private _i18n: I18n, private i18nPluralPipe: I18nPluralPipe) {}

    public transform(val: string | Date | number): string {
        if (typeof val === 'string') {
            val = new Date(val);
        }
        if (typeof val === 'number') {
            val = new Date(val);
        }

        const timeDifference = new Date().getTime() - val.getTime();
        const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

        return this.i18nPluralPipe.transform(daysDifference, {
            '=0': this._today,
            '=1': this._singleDay,
            other: this._multipleDays
        });
    }
}
